/* eslint-disable no-shadow */
import _ from "lodash";
import Vue from 'vue';

const state = {
  lang: 'zh-tw',
  langtext: {
    dis_list: {
      off: '折價',
      discount: '折扣',
      true: '是',
      false: '否',
    },
  },
};

const actions = {
  showToast({
    commit
  }, {
    title,
    method,
    text,
    time,
    toaster,
  }) {
    (new Vue).$bvToast.toast(text, {
      title: title,
      variant: method || "info",
      toaster: toaster || "b-toaster-top-right",
      solid: true,
      // noAutoHide:true
      autoHideDelay: time || 10000,
    })
  },
  openConfirm({
    commit
  }, data) {
    console.log(data);
    const h = (new Vue).$createElement;
    const context = data.context || "是否要取消";
    const message = h("div", {}, context);
    const titleVNode = h('div', {
      class: 'h4'
    }, data.title || "取消確認");
    return (new Vue).$bvModal.msgBoxConfirm(message, {
      title: [titleVNode],
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true,
      size: 'sm',
      okVariant: 'danger',
      okTitle: 'YES',
      cancelTitle: 'NO',
    })
  }
};

const mutations = {

};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
